"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// import "babel-polyfill";
//
// class Foo {
//   method() {}
// }

// 依赖 jquery
function EventToShow() {
  var _this = this;
  this.options = {
    // String --- One or more space-separated classes to be removed from the class attribute of each matched element.
    receiveClassName: 'active',
    triggerClassName: 'active',
    eventType: 'click',
    // Event
    evtTgrStr: 'data-event-tgr',
    attr: {
      tgrStr: 'data-ets-trigger',
      rveStr: 'data-ets-relevance'
    }
  };
  this._$triggerElemLists = $("[" + this.options.evtTgrStr + "]");
  this._$groupObj = this._group(this._$triggerElemLists);
}
EventToShow.prototype.globalInit = function () {
  this._bindEvent(this._$groupObj);
};

/**
 * 根据关联性(relevance)分组
 * @private
 */
EventToShow.prototype._group = function ($elems) {
  var obj = {};
  var _this = this;
  // 无关联目标的前缀
  var _noRve = '_noRve_';
  $elems.each(function (index, elem) {
    var $elem = $(elem);
    var attrVal = $elem.attr(_this.options.attr.rveStr);
    if (!attrVal) {
      return obj[_noRve + index] = [elem];
    }
    if ($.isArray(obj[attrVal])) {
      obj[attrVal].push(elem);
    } else {
      obj[attrVal] = [elem];
    }
  });
  return obj;
};

/**
 * 切换class
 * @param elem_add [Jquery|JquerySelector] 要新增class的元素
 * @param elem_del [Jquery|JquerySelector] 要删除class的元素
 * @param o_className class的值
 * @return {boolean} 处理成功与否状态
 * @private
 */
EventToShow.prototype._switchClass = function (elem_add, elem_del, o_className) {
  var $elem_add = $(elem_add);
  var $elem_del = $(elem_del);
  // 同一元素
  var is_same_val = elem_add === elem_del;
  if (is_same_val) {
    // $elem_add.toggleClass(o_className);
    return true;
  }
  $elem_add.addClass(o_className);
  $elem_del && $elem_del.removeClass(o_className);
  return true;
};
EventToShow.prototype._bindEvent = function (elems, eventType) {
  eventType = eventType || this.options.eventType;
  var _this = this;
  $.each(elems, function (key, values) {
    var lastElemIndex = 0;
    $.each($(values), function (index, elem) {
      if ($(elem).hasClass('active')) {
        lastElemIndex = index;
      }
    });
    $.each(values, function (index, elem) {
      var $elem = $(elem);
      $elem.on(eventType, function (event) {
        console.log("$elem.on::" + eventType + " is triggering!", $(this).get());
        var newTgrVal = $elem.attr(_this.options.evtTgrStr);
        var oldTgrVal = $(values[lastElemIndex]).attr(_this.options.evtTgrStr);
        _this._switchClass(elem, values[lastElemIndex], _this.options.triggerClassName);
        lastElemIndex = index;
        if (newTgrVal) {
          _this._switchClass("#" + newTgrVal, "#" + oldTgrVal, _this.options.receiveClassName);
        }
      });
    });
  });
};
exports.default = EventToShow;